// Copyright 2021-2024, 2026 - Hewlett Packard Enterprise Company
import { useHistory } from 'react-router-dom';
import { AuthConsumer } from '../contexts/AuthContext';
import { postLoginRedirect } from '../utils/authHelpers';
import {
  COM_TAB_MARKER_PREFIX,
  EMAIL_LINK_TENANT_KEY,
} from '../constants/authConst';

export default function AuthCallback() {
  const history = useHistory();
  return (
    <AuthConsumer>
      {({ signinRedirectCallback }) => {
        signinRedirectCallback()
          .then(() => {
            window.name = `${COM_TAB_MARKER_PREFIX}${window.indigo.REACT_APP_COM_API_ROOT_URL}`;
            // Clean up email link tenant flag now that auth is complete
            sessionStorage.removeItem(EMAIL_LINK_TENANT_KEY);
            postLoginRedirect(history);
          })
          .catch(() => {
            // Clean up email link tenant flag on auth failure
            sessionStorage.removeItem(EMAIL_LINK_TENANT_KEY);
            // TODO: Possibly display an error message with a link to GLP login page.
            // eslint-disable-next-line no-console
            console.log('Unable to authenticate user. Redirect to CCS login');
          });
        return <span>Authenticating ...</span>;
      }}
    </AuthConsumer>
  );
}
